{
  "base.disabled": "disabled",
  "base.tow": "Request a tug (~{hours} h · standing −{reputation})",
  "base.wait.menu": "Wait …",
  "base.wait.hours": "{hours} h",
  "base.wait.call": "Until the next call",
  "base.wait.back": "Back",
  "briefing.disabled": "This vessel is disabled. A tug has to bring it home first.",
  "map.disabled.fuel": "{vessel}: tanks dry. We're drifting.",
  "map.disabled.hull": "{vessel}: hull breached. We're dead in the water.",
  "voyage.evidence.redundant": "Recorded — but the file already has what it needs on that.",
  "voyage.refused": "The crew refuses the detour.",
  "evidence.cost": "Recovered from the {name} · {count, plural, one {# lost} other {# lost}}",
  "evidence.cost.avoidable": "Recovered from the {name} · {count, plural, one {# lost} other {# lost}} — there would have been time",
  "settings.motion": "Motion",
  "settings.motion.full": "full",
  "settings.motion.reduced": "reduced",
  "settings.fullscreen": "Fullscreen",
  "settings.fullscreen.on": "on",
  "settings.fullscreen.off": "off",
  "settings.volume.master": "Volume",
  "settings.volume.ambience": "Ambience & sea",
  "settings.volume.effects": "Signals & sonar",
  "imprint.privacy.body.itch": "The game runs entirely in the browser. No server, no accounts, no cookies, no audience measurement of our own — the terms of itch.io, which delivers this version, apply. Local storage holds only the save game and settings; none of it leaves the device.",
  "toll.title": "The price",
  "toll.rescued": "{count} rescued",
  "toll.lost": "{count} lost",
  "toll.morale": "Crew {value} % · {mood}",
  "toll.mood.steady": "steady",
  "toll.mood.strained": "strained",
  "toll.mood.grim": "bitter",
  "toll.mood.breaking": "breaking",
  "toll.avoidable": "Of those, {count, plural, one {# person} other {# people}} could have been saved.",
  "toll.verdict.clean": "Nobody died while you were searching. That almost never happens.",
  "toll.verdict.balanced": "You pulled more people out of the water than you lost. And the case was still solved.",
  "toll.verdict.costly": "The truth cost lives that did not have to be lost. The file does not mention them.",
  "toll.verdict.ruthless": "Every piece of hard evidence cost dozens who could still have been saved. The station will not forget it.",
  "toll.verdict.unavoidable": "Those who were lost were lost before you could have been there.",
  "toll.remark.steady": "“We're holding. For now.”",
  "toll.remark.strained": "Nobody says the last names out loud. Everybody thinks them.",
  "toll.remark.grim": "“How many more until you have what you want?” Nobody answers.",
  "toll.remark.breaking": "The engineer has cleared out his bunk. He wants off as soon as we make port.",
  "sonar.title": "Sonar search",
  "sonar.help": "The wreck is not at the reported position. Place the marker in the field and ping: the echo tells you the distance, not the direction. Dive where the rings intersect.",
  "sonar.ping": "Ping ({left})",
  "sonar.dive": "Dive here",
  "sonar.skip": "Dive at the reported position",
  "sonar.left": "{count, plural, one {# ping} other {# pings}} left",
  "sonar.echo": "Echo after {seconds} s · {metres} m",
  "sonar.scale": "Field 2 × 2 nm",
  "sonar.continue": "Continue",
  "sonar.result.found": "Contact. The hull lies right beneath you — and more of it than the report suggested.",
  "sonar.result.missed": "Only sand and darkness. The wreck lay elsewhere; there is no time for a second dive.",
  "sonar.result.skipped": "Dived at the reported position.",
  "sonar.summary.found": "The search paid off: you found more than the reported position would have yielded.",
  "sonar.summary.missed": "The search came up empty. Whatever lay at the wreck stays there.",
  "sonar.summary.skipped": "Dived without a search — the usual yield.",
  "sonar.result.found_empty": "Contact. The wreck lies beneath you — but nothing on it moves the file forward right now.",
  "sonar.summary.found_empty": "The wreck was found, but there was nothing left there that this act needs.",
  "briefing.depart.blocked": "Disabled – needs a tug"
}
